import React from 'react';
import { EmployeeLinkWithAccessCheck } from 'domain/shared/employee';
import { FEEDBACK_OBTAINED } from 'domain/people/feedback/instantFeedback/input/ObtainedDropdown';

type FeedbackOnBehalfProps = {
  onBehalfOf?: string;
  onBehalfOfEmployee?: string;
  onBehalfOfEmployeeName?: string;
  obtainedBy?: string;
};

const FeedbackOnBehalf = ({
  onBehalfOf,
  onBehalfOfEmployee,
  onBehalfOfEmployeeName,
  obtainedBy,
}: FeedbackOnBehalfProps) => {
  let result: React.ReactElement | string = ' ';

  const obtainedByValue = obtainedBy ? FEEDBACK_OBTAINED[obtainedBy] : null;

  if (onBehalfOf) {
    result += `(on ${onBehalfOf}'s behalf${obtainedByValue ? ` from ${obtainedByValue})` : ')'}`;
  }

  if (onBehalfOfEmployee) {
    result = (
      <>
        {'(on '}
        <EmployeeLinkWithAccessCheck id={onBehalfOfEmployee} name={onBehalfOfEmployeeName} />
        `s behalf{obtainedByValue ? ` from ${obtainedByValue}` : ''})
      </>
    );
  }

  return result;
};

export default FeedbackOnBehalf;
